import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useAuthStore = create(
  persist(
    (set) => ({
      user: null,
      token: null,
      setToken: (token) => set({ token }),
      loginAction: (data) => {
        let token = data.accessToken;

        if (token && typeof token === 'object') {
          token = token.accessToken || token.token || token.data;
        }

        set({
          user: data.user,
          token: token
        });
      },
      logout: () => {
        set({
          user: null,
          token: null
        });
      },
    }),
    {
      name: 'auth-storage', // name of the item in the storage (must be unique)
    }
  )
);
